export const rosterFields='id,name,email,license,signature,user_id';
export function reportInspector(row){return {id:row.id,name:row.name,email:row.email||'',license:row.license||'',signature:row.signature||'',userId:row.user_id||null};}
export function inspectorRow(value){
 const name=String(value.name||'').trim();if(!name)throw Error('Enter the inspector’s name.');
 const email=String(value.email||'').trim().toLowerCase();if(email&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))throw Error('Enter a valid email address.');
 return {id:String(value.id),name,email,license:String(value.license||'').trim(),signature:value.signature||''};
}
export async function loadInspectorRoster(client,legacy=[],importLegacy=false){
 const {data,error}=await client.from('firm_inspectors').select(rosterFields).order('name');if(error)throw Error('Could not load the shared inspector roster. Please retry.');
 const rows=data||[];
 if(importLegacy){
  const ids=new Set(rows.map(r=>r.id));
  for(const item of legacy){if(!item?.id||!item.name?.trim()||ids.has(String(item.id)))continue;
   const row=inspectorRow(item);const {error:saveError}=await client.from('firm_inspectors').insert(row);if(saveError&&saveError.code!=='23505')throw Error('Could not save an existing inspector to the shared roster. Please retry.');ids.add(row.id);
  }
  if(ids.size!==rows.length)return loadInspectorRoster(client);
 }
 return rows;
}

// Assignment IDs are verified login UUIDs, independent of office account role.
export function assignableInspectors(profiles,roster){
 const seen=new Set();
 return roster.flatMap(ins=>{
  const id=ins.userId||ins.user_id;
  const profile=profiles.find(p=>p.id===id&&p.active===true);
  if(!profile||seen.has(id))return [];
  seen.add(id);
  return [{...profile,full_name:ins.name||profile.full_name,license:ins.license||''}];
 }).sort((a,b)=>(a.full_name||a.email||'').localeCompare(b.full_name||b.email||''));
}

// Report credential IDs may be legacy IDs; assignment IDs are login UUIDs.
// Resolve only the explicit roster link, with assignment taking precedence.
export function withReportInspector(job,roster,currentUserId){
 if(job.inspectionSubmitted)return job;
 const accountId=job.assignedTo||currentUserId;
 if(!accountId)return job;
 const inspector=roster.find(row=>(row.userId||row.user_id)===accountId);
 if(!inspector)return job;
 const ids=job.inspectorIds||[];
 const same=job.autoInspectorAccountId===accountId&&job.autoInspectorId===inspector.id;
 if(same&&ids[0]===inspector.id)return job;
 const keepAdditional=same||(!job.autoInspectorAccountId&&ids.includes(inspector.id));
 return {...job,inspectorIds:[inspector.id,...(keepAdditional?ids.filter(id=>id!==inspector.id):[])],autoInspectorAccountId:accountId,autoInspectorId:inspector.id};
}
